import type { SVGProps } from 'react';

const SvgAnalytics = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="analytics">
      <path d="M3 31.27h18.3a2.76 2.76 0 0 0 2.75-2.75v-1.77h-1.5v1.77a1.25 1.25 0 0 1-1.25 1.25H3a1.26 1.26 0 0 1-1.25-1.25v-25A1.26 1.26 0 0 1 3 2.23h18.3a1.25 1.25 0 0 1 1.25 1.25v3.58h1.5V3.48A2.76 2.76 0 0 0 21.3.73H3A2.76 2.76 0 0 0 .27 3.48v25A2.76 2.76 0 0 0 3 31.27" />
      <path d="M4.99 16.03h1.5v8.54h-1.5zM9.07 6.93h1.5v17.64h-1.5zM23.3 8.93a8.2 8.2 0 1 0 8.19 8.2 8.21 8.21 0 0 0-8.19-8.2m6.7 7.45h-5.9v-5.91a6.72 6.72 0 0 1 5.9 5.91m-6.7 7.44a6.7 6.7 0 0 1-.75-13.35v6.66a.75.75 0 0 0 .75.75H30a6.7 6.7 0 0 1-6.7 5.94" />
    </g>
  </svg>
);

export default SvgAnalytics;
